import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { defaultConfig } from './default-config';
import { NewFormService, CustomFormService } from './form-service';
import { FormConfigPropsShape } from './form-props';

export const Form = (props) => {
  const {
    config,
    children,
  } = props;

  const mergedConfig = useMemo(() => ({
    ...defaultConfig,
    ...config,
  }), [config]);

  const { render, machineOptions } = mergedConfig;
  const { machineService } = machineOptions;

  const FormService = machineService ? CustomFormService : NewFormService;

  return (
    <FormService config={mergedConfig}>
      {children || render()}
    </FormService>
  );
};

Form.propTypes = {
  config: PropTypes.shape(FormConfigPropsShape).isRequired,
  children: PropTypes.node,
};

Form.defaultProps = {
  children: null,
};
